import SubmissionsCarousel from '../components/submission/submissions-carousel';

/* @ngInject */
export default function NvSubmissionsCarousel(
  _,
  moment,
  CurrentCourseManager,
  CurrentUserManager,
  config,
) {
  return {
    scope: {
      acountForTimelineWidth: '=?',
      submissions: '=?', // this is all the submissions that can be display
      carouselSubmissions: '=', // this seems to be a clone or a subset of submissions, apparently slick carousel breaks if we try to update the original set

      submissionsReleased: '=?', // only show submissions if released, if no released, show error message

      showApprovalProgress: '=?',
      showApprovalPendingTime: '=?',
      showDueDate: '=?',
      showRevisionRemainderTime: '=?',
      hideSocial: '=?',
      showCourseHeaderInLink: '=?',

      isPublicFeedbackOn: '=?', // if this is a carouself for public feedback, we display a public feedback specific error message
      requiredExercise: '=?', // relevant exercise for this set for submissions
    },

    controller: function ctrl($scope) {
'ngInject';
      const vm = this;
      const currentMoment = moment();
      let deadlineMoment;
      let releaseDateMoment;
      vm.config = config;
      vm.isContentManagementCollection = CurrentCourseManager?.course?.isContentManagementCollection;
      vm.sliderComponent = null;

      _.extend(vm, {
        CurrentCourseManager,
        CurrentUserManager,

        // data
        filterOption: this.isPublicFeedbackOn ? 'not_my_comments' : null,
        // functions
        dateValue,
      });

      if (vm.requiredExercise) {
        deadlineMoment = moment(vm.requiredExercise.deadline);
        releaseDateMoment = moment(vm.requiredExercise.releaseDate);
      }

      function dateValue() {
        if (vm.requiredExercise) {
          const dateToFormat = moment(vm.requiredExercise.submissionsViewableBeforeDeadline ? releaseDateMoment : deadlineMoment);

          return dateToFormat.format(dateToFormat.isSame(currentMoment, 'year') ? 'MOMENT.MONTH_DAY_AT_TIME' : 'MOMENT.MONTH_DAY_COMMA_YEAR_AT_TIME');
        }

        return null;
      }

      const setCenteredView = _.debounce(() => {
        $(vm.sliderComponent).slick('setPosition');
      }, 100);

      $scope.SubmissionsCarousel = () => (
        <SubmissionsCarousel
          submissions={vm.carouselSubmissions}
          isPublicFeedbackOn={vm.isPublicFeedbackOn}
          showApprovalStatus={vm.showApprovalProgress}
          showApprovalPendingTime={vm.showApprovalPendingTime}
          showDueDate={vm.showDueDate}
          showRevisionRemainderTime={vm.showRevisionRemainderTime}
          hideSocial={vm.hideSocial}
          showCourseHeaderInLink={vm.showCourseHeaderInLink}
        />
      );

      angular.element('.lecture-page-main-content').on('resize', setCenteredView);
      $scope.$on('$destroy', () => {
        angular.element('.lecture-page-main-content').off('resize', setCenteredView);
      });
    },
    controllerAs: 'vm',
    bindToController: true,
    transclude: true,
    templateUrl: 'shared/templates/nv-submissions-carousel.html',
  };
}
